<template>
<div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "style/reset.module.scss";
@import "style/rwd.module.scss";
@import "style/icons.module.scss";

i.close {
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>
